import ProgramYearList from 'frontend/components/program-year/list';
<template><ProgramYearList @canCreate={{@controller.canCreate}} @program={{@model}} /></template>
